import './sliders.js'
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const screenHeight = () => {
    var vh = window.innerHeight;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

const mq = window.matchMedia('(max-width: 840px)'),
    allClients = gsap.utils.toArray('.servicios__item--client'),
    allProjects = gsap.utils.toArray('.projects__item'),
    largeImage = document.querySelector('.container__image'),
    lInside = document.querySelector('.container__image .image_inside'),
    isMobile = window.innerWidth < 840,

    body = document.querySelector('body');
let titlePinTrigger;  // aquí guardaremos la instancia

function init() {
    screenHeight();
    toggleMenuBehavior();

    if (!document.body.classList.contains('home')) {
        toggleMode()
        initScrollUpHeader();
    }
    if (document.body.classList.contains('home')) {
        generativeGrid();
        if (isMobile) {
            document.addEventListener('touchstart', () => {
                document.body.classList.add('is-touching');
            }, {passive: true});

            let scrollingFromTouch = false;

            document.addEventListener('scroll', () => {
                if (scrollingFromTouch) {
                    document.body.classList.add('is-touching');
                }
            }, {passive: true});

            document.addEventListener('touchmove', () => {
                scrollingFromTouch = true;
            }, {passive: true});

            document.addEventListener('touchend', () => {
                document.body.classList.remove('is-touching');
                scrollingFromTouch = false;
            }, {passive: true});

        }
    }

    if (document.body.classList.contains('archive__projects')) {
        toggleArchiveMenu(allProjects);
    }
    if (document.body.classList.contains('single-project')) {

        if (isMobile) {
            moreImagesProject();
        }
        if (!isMobile) {
            portfolioPinHeader();
            initProjectArchiveGallery();
        }
    }
    if (document.body.classList.contains('archive__servicios')) {
        toggleServices();
        if (!isMobile) {
            initPortfolioHover(allClients);
            pinTop();
        }
    }

    if (document.body.classList.contains('page__about')) {
        if (!isMobile) {
            // pinTitles();
            marqueeCentering();
            pinTop();
        }
    }
    if (document.body.classList.contains('page__contacto')) {
        if (!isMobile) {
            pinContact();
        }
    }
}

window.onload = (event) => {
    console.log('page is fully loaded');
    init();

};

window.addEventListener('resize', screenHeight())


// NAVIGATION
function toggleMenuBehavior() {
    const menuCheckbox = document.getElementById('menu');
    const header = document.querySelector('header');

    if (menuCheckbox && header) {
        menuCheckbox.addEventListener('change', () => {
            header.classList.toggle('menu-open', menuCheckbox.checked);
            document.body.classList.toggle('overflow-hidden');
        });
    }
}

function toggleArchiveMenu(allProjects) {
    const btn = document.querySelector('.project-header__btn');
    const body = document.body;
    if (!btn) return;

    btn.addEventListener('click', () => {
        body.classList.toggle('archive-open');
        btn.textContent = body.classList.contains('archive-open') ? 'Galería' : 'Archivo';

        // SOLO cuando esté abierto y en desktop
        if (body.classList.contains('archive-open')) {
            initPortfolioHover(allProjects);
        } else {
            // si acabamos de cerrar (o no es desktop)
            destroyPortfolioHover(allProjects);
        }
    });
}

function destroyPortfolioHover(selectors) {
    // 1) Quitar los listeners que añadimos en initPortfolioHover
    selectors.forEach(link => {
        link.removeEventListener('mouseenter', createPortfolioHover);
        link.removeEventListener('mouseleave', createPortfolioHover);
        link.removeEventListener('mousemove', createPortfolioMove);
    });

    // 2) Parar cualquier tween activo sobre largeImage
    if (typeof gsap !== 'undefined' && window.largeImage) {
        gsap.killTweensOf(largeImage);
        // 3) Asegurarnos de que queda oculta
        gsap.set(largeImage, {autoAlpha: 0});
    }
}


function toggleMode() {
    const toggleBtn = document.getElementById('theme-toggle');
    const currentTheme = localStorage.getItem('theme')
        || (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');

    document.documentElement.setAttribute('data-theme', currentTheme);
    const body = document.body;
    toggleBtn.addEventListener('click', () => {
        const newTheme = document.documentElement.getAttribute('data-theme') === 'dark'
            ? 'light' : 'dark';
        document.documentElement.setAttribute('data-theme', newTheme);
        localStorage.setItem('theme', newTheme);
        body.classList.toggle('dark-mode');
    });
}


// PROJECTS //
function initPinOnDesktop() {
    const content = document.querySelector(".project-content");
    const wrapper = content.querySelector(".project-content__archive");

    titlePinTrigger = ScrollTrigger.create({
        trigger: content,
        start: "top+=20 top",
        end: () => `bottom top+=20`,
        pin: wrapper,
        pinSpacing: true, // si quieres que cree el "pin-spacer"; es el defecto
        onToggle: self => {
            wrapper.classList.toggle("is-pinned", self.isActive);
        },
        // Opcional: markers: true
    });
}


// Animation over projects

function initPortfolioHover(selectors) {
    selectors.forEach(link => {
        link.addEventListener('mouseenter', createPortfolioHover);
        link.addEventListener('mouseleave', createPortfolioHover);
        // link.addEventListener('mousemove', createPortfolioMove);
    });
}

function imageGalleryPostion() {
    const imageWidth = largeImage.offsetWidth
    return '100px'
}

function getCenterPosition(element) {
    const rect = element.getBoundingClientRect();
    return rect.top - rect.height / 0.25; // posición del centro respecto al viewport
}

function createPortfolioHoverold(e) {

    if (e.type === 'mouseenter') {
        const {imageproject} = e.target.dataset;
        var projectType = e.target.classList[1];

        const tl = gsap.timeline();
        if (projectType === 'vertical') {
            var xWidth = '15rem';
            var yHeight = '22.5rem';
        } else {
            var xWidth = '22.5rem';
            var yHeight = '15rem';
        }
        tl
            .set(lInside, {backgroundImage: `url(${imageproject})`})
            .set(largeImage, {
                yPercent: posY,
                x: imageGalleryPostion(),
                autoAlpha: 0,
                width: xWidth,
                height: yHeight})
            .to(largeImage, {
                autoAlpha: 1,
                duration: 0.6})
            .to(e.target, {autoAlpha: 1}, 0);

    } else if (e.type === 'mouseleave') {

        const tl = gsap.timeline();
        tl
            .to(largeImage, {autoAlpha: 0, duration: 0.5})
    }

}

function createPortfolioHover(e) {
    if (e.type === 'mouseenter') {
        const { imageproject } = e.target.dataset;
        var projectType = e.target.classList[1];

        const tl = gsap.timeline();
        if (projectType === 'vertical') {
            var xWidth = '15rem';
            var yHeight = '22.5rem';
        } else {
            var xWidth = '22.5rem';
            var yHeight = '15rem';
        }

        // Calcular centro vertical del item hovered
        const centerY = getCenterPosition(e.target);
        const largeImageHeight = parseFloat(yHeight); // en rem
        const largeImageHeightPx = largeImageHeight * parseFloat(getComputedStyle(document.documentElement).fontSize);

        const posY = centerY - (largeImageHeightPx / 2);

        tl
            .set(lInside, { backgroundImage: `url(${imageproject})` })
            .set(largeImage, {
                y: posY,
                x: imageGalleryPostion(),
                autoAlpha: 0,
                width: xWidth,
                height: yHeight
            })
            .to(largeImage, {
                autoAlpha: 1,
                duration: 0.1
            })
            .to(e.target, { autoAlpha: 1 }, 0);

    } else if (e.type === 'mouseleave') {
        const tl = gsap.timeline();
        tl.to(largeImage, { autoAlpha: 0, duration: 0.1 });
    }
}


function createPortfolioMove(e) {
    const link = e.currentTarget; // el <a> que dispara el evento
    const offsetY = getPortfolioOffsetY(e, link);

    gsap.to(largeImage, {
        duration: 0.4,
        ease: 'power3.out'
    });
}

function getPortfolioOffsetY(e, link) {

    const rect = link.getBoundingClientRect();

    // Por ejemplo, para centrar la imagen bajo el cursor:
    // return e.clientY - rect.top - (largeImage.offsetHeight / 2);
    return -(rect.height - e.clientY / 2 + largeImage.offsetHeight / 2);

}

function initProjectArchiveGallery() {
    const container = document.querySelector('.project-content__archive');
    const gallery   = container.querySelector('.project-content__archive--gallery');
    const openBtn   = container.querySelector('.project-content__archive--btn');
    const closeBtn  = container.querySelector('.content__archive--close');
    const body      = document.body;
    const titlePinTrigger = window.titlePinTrigger;
    const archivePin = ScrollTrigger.getById('archivePin');

    if (!container || !openBtn || !closeBtn) return;

    /* ----------- Nuevo moveCloseBtn ------------ */
    const moveCloseBtn = e => {
        const galleryRect = gallery.getBoundingClientRect();
        const galleryTop  = galleryRect.top + window.pageYOffset;
        const galleryLeft = galleryRect.left + window.pageXOffset;

        // posición del cursor dentro del contenedor
        const y = e.pageY - galleryTop;
        const x = e.pageX - galleryLeft;

        // tamaño del botón
        const { width: w, height: h } = closeBtn.getBoundingClientRect();

        // centramos en el cursor
        closeBtn.style.left = `${x - w/2}px`;
        closeBtn.style.top  = `${y - h/2}px`;
    };

    const outsideClickHandler = () => closeGallery();

    const openGallery = () => {
        // asegúrate de mover el botón dentro del scrollable
        gallery.appendChild(closeBtn);

        archivePin.disable(true);            // quitamos también el transform
        container.classList.add('is-open');
        body.classList.add('gallery-is-open');
        openBtn.setAttribute('aria-expanded', 'true');
        titlePinTrigger?.disable?.();

        closeBtn.style.opacity = 1;
        closeBtn.style.pointerEvents = 'auto';

        window.addEventListener('mousemove', moveCloseBtn);
        setTimeout(() => {
            window.addEventListener('click', outsideClickHandler, { once: true });
        }, 0);
    };

    const closeGallery = () => {
        window.removeEventListener('mousemove', moveCloseBtn);
        window.removeEventListener('click', outsideClickHandler);

        closeBtn.style.opacity = 0;
        closeBtn.style.pointerEvents = 'none';

        container.classList.remove('is-open');
        body.classList.remove('gallery-is-open');
        archivePin.enable();
        openBtn.setAttribute('aria-expanded', 'false');
        titlePinTrigger?.enable?.();
    };

    openBtn.addEventListener('click', () => {
        return container.classList.contains('is-open') ? closeGallery() : openGallery();
    });

    closeBtn.addEventListener('click', e => {
        e.stopPropagation();
        closeGallery();
    });

    if (container.classList.contains('is-open')) openGallery();
}

function moreImagesProject() {
    const btn = document.querySelector('.project-content__archive--btn');
    const container = document.querySelector('.project-content__archive');
    const body = document.body;

    btn.addEventListener('click', () => {
        const isOpen = btn.getAttribute('aria-expanded') === 'true';

        // Alterna clases en el contenedor y body
        container.classList.toggle('is-open', !isOpen);
        body.classList.toggle('gallery-is-open', !isOpen);

        //  Si “isOpen” era true, significa que vamos a CERRAR,
        //  si “isOpen” era false, vamos a ABRIR.
        if (isOpen) {
            // Estamos cerrando: reactivamos el pin si existía
            btn.setAttribute('aria-expanded', 'false');
        } else {
            // Estamos abriendo la galería: deshabilitamos el pin
            btn.setAttribute('aria-expanded', 'true');
        }
    });
}

// END PROJECTS //


// SERVICES //
function toggleServices() {
    const buttons = document.querySelectorAll('.servicios__item--btn');
    const isMobile = window.innerWidth < 840;

    buttons.forEach((btn, index) => {
        const container = btn.closest('.servicios__item');

        if (isMobile) {
            // En mobile: todos cerrados
            btn.setAttribute('aria-expanded', 'false');
            container.classList.remove('is-open');
        } else {
            // En desktop: el primero abierto, el resto cerrados
            if (index === 0) {
                btn.setAttribute('aria-expanded', 'true');
                container.classList.add('is-open');
            } else {
                btn.setAttribute('aria-expanded', 'false');
                container.classList.remove('is-open');
            }
        }
    });

    buttons.forEach(btn => {
        btn.addEventListener('click', () => {
            const container = btn.closest('.servicios__item');
            const wasOpen = container.classList.contains('is-open');

            // Cerrar todos
            buttons.forEach(otherBtn => {
                const otherContainer = otherBtn.closest('.servicios__item');
                otherBtn.setAttribute('aria-expanded', 'false');
                otherContainer.classList.remove('is-open');
            });

            // Abrir el actual si no estaba abierto
            if (!wasOpen) {
                btn.setAttribute('aria-expanded', 'true');
                container.classList.add('is-open');
            }
        });
    });
}


// END SERVICES //


// HOME //

function generativeGrid() {
    // 1) Definimos los dos posibles “mapas” de posiciones:
    const gridMap1 = {
        1: {col: "1 / 3", row: "1 / 2"},
        2: {col: "7 / 10", row: "1 / 2"},
        3: {col: "2 / 7", row: "2 / 3"},
        4: {col: "9 / 10", row: "2 / 3"},
        5: {col: "1 / 5", row: "3 / 5"},
        6: {col: "7 / 9", row: "3 / 4"},
        7: {col: "8 / 10", row: "4 / 5"},
        8: {col: "1 / 9", row: "5 / 6"},
        9: {col: "9 / 10", row: "6 / 7"},
        10: {col: "6 / 9", row: "7 / 9"},
        11: {col: "9 / 10", row: "7 / 8"},
        12: {col: "1 / 4", row: "9 / 11"},
        13: {col: "4 / 6", row: "9 / 10"},
        14: {col: "6 / 10", row: "10 / 11"}
    };

    const gridMap2 = {
        1: {col: "3 / 6", row: "1 / 2"},
        2: {col: "1 / 3", row: "2 / 4"},
        3: {col: "6 / 10", row: "2 / 3"},
        4: {col: "9 / 10", row: "3 / 4"},
        5: {col: "2 / 9", row: "4 / 6"},
        6: {col: "9 / 10", row: "5 / 6"},
        7: {col: "1 / 2", row: "6 / 7"},
        8: {col: "2 / 10", row: "7 / 8"},
        9: {col: "1 / 4", row: "8 / 9"},
        10: {col: "7 / 10", row: "8 / 10"},
        11: {col: "4 / 5", row: "9 / 11"},
        12: {col: "1 / 4", row: "11 / 13"},
        13: {col: "5 / 9", row: "11 / 12"},
        14: {col: "9 / 10", row: "11 / 12"}
    };
    const gridMap3 = {
        1: {col: "1 / 3", row: "1 / 2"},
        2: {col: "7 / 8", row: "1 / 2"},
        3: {col: "3 / 8", row: "2 / 3"},
        4: {col: "1 / 3", row: "3 / 6"},
        5: {col: "5 / 8", row: "4 / 5"},
        6: {col: "3 / 5", row: "5 / 6"},
        7: {col: "5 / 8", row: "6 / 8"},
        8: {col: "1 / 4", row: "7 / 8"},
        9: {col: "4 / 5", row: "8 / 9"},
        10: {col: "1 / 4", row: "9 / 10"},
        11: {col: "4 / 8", row: "10 / 12"},
        12: {col: "1 / 2", row: "11 / 12"},
        13: {col: "2 / 4", row: "12 / 13"},
        14: {col: "4 / 6", row: "13 / 14"}
    };
    const allMaps = [gridMap1, gridMap2, gridMap3];

    // 2) Referencias
    const gridContainer = document.querySelector('.grid-container');
    const bodyEl = document.body;
    if (!gridContainer) return;

    // 3) Leemos del localStorage el índice previo
    const prevRaw = localStorage.getItem('lastGridIndex');
    const prevIndex = prevRaw !== null ? parseInt(prevRaw, 10) : null;

    // 4) Elegimos un índice aleatorio distinto (si hay al menos 2 opciones)
    let randomIndex;
    do {
        randomIndex = Math.floor(Math.random() * allMaps.length);
    } while (
        allMaps.length > 1 &&
        prevIndex !== null &&
        randomIndex === prevIndex
        );

    // 5) Guardamos el nuevo en localStorage
    localStorage.setItem('lastGridIndex', randomIndex);

    // 6) Limpiamos clases antiguas y añadimos la nueva
    for (let i = 1; i <= allMaps.length; i++) {
        gridContainer.classList.remove(`grid${i}`);
        bodyEl.classList.remove(`grid${i}`);
    }
    const className = `grid${randomIndex + 1}`;
    gridContainer.classList.add(className);
    bodyEl.classList.add(className);

    // 7) Aplicamos el layout
    const layoutMap = allMaps[randomIndex];
    document.querySelectorAll('.grid-item').forEach(el => {
        const pos = el.dataset.pos;
        const layout = layoutMap[pos];
        if (!layout) return;
        el.style.gridColumn = layout.col;
        el.style.gridRow = layout.row;
    });
}

// END HOME

// ABOUT//

function pinTitles() {
    const title = Array.from(document.querySelectorAll('.content__title'));
    const subcontent = document.querySelector(".subcontent");

    title.forEach((el, i) => {
        const next = title[i + 1];
        ScrollTrigger.create({
            trigger: el,
            start: "top-=60 top",
            pin: el,
            pinSpacing: false,
        });
    });
    ScrollTrigger.create({
        trigger: subcontent,
        start: "top-=60 top",
        pin: subcontent,
        pinSpacing: false,
    });
}

function pinTopold() {
    const topFixed = Array.from(document.querySelectorAll('.top-fixed'));

    topFixed.forEach((el, i) => {
        const next = topFixed[i + 1];
        ScrollTrigger.create({
            trigger: el,
            start: "top-=60 top",
            pin: el,
            pinSpacing: false,
            end: "bottom center-=10%",
        });
    });
}

function pinTopnew() {
    const sections = document.querySelectorAll('section.content');

    sections.forEach((section, idx) => {
        // Todos los elementos .top-fixed dentro de esta sección
        const tops = section.querySelectorAll('.top-fixed');
        // La sección que viene después (si no hay, fallback a esta misma sección)
        const nextSection = sections[idx + 1];

        tops.forEach(el => {
            ScrollTrigger.create({
                trigger: el,
                start:   "top-=60 top",                          // se fija 60px después de entrar
                endTrigger: nextSection || section,              // hasta la siguiente sección (o la misma si es la última)
                end:     nextSection ? "top center" : "bottom top", // si hay nextSection, su top; si no, el bottom de esta sección
                pin:     el,
                pinSpacing: false,
                // pinReparent: true,  // en caso de conflictos de stacking
                markers: true,      // descomenta para depurar
            });
        });
    });
}

function pinTop() {
    const sections = document.querySelectorAll('section.content');

    //  A) Encabezados (h2.top-fixed) hasta la siguiente sección
    sections.forEach((section, idx) => {
        // Todos los elementos .top-fixed dentro de esta sección
        const tops = section.querySelectorAll('.top-fixed');
        // La sección que viene después (si no hay, fallback a esta misma sección)
        const nextSection = sections[idx + 1];

        tops.forEach(el => {
            ScrollTrigger.create({
                trigger: el,
                start:   "top-=60 top",                          // se fija 60px después de entrar
                endTrigger: nextSection || section,              // hasta la siguiente sección (o la misma si es la última)
                end:     nextSection ? "top center" : "bottom top", // si hay nextSection, su top; si no, el bottom de esta sección
                pin:     el,
                pinSpacing: false,
                // pinReparent: true,  // en caso de conflictos de stacking
                // markers: true,      // descomenta para depurar
            });
        });
    });

    //  B) Contenido de fila (.row-pinned) hasta que su fila llegue al top
    document.querySelectorAll('.row-pinned').forEach(el => {
        console.log(el);
        const row = el.closest('.content__info--row');
        if (!row) return;

        ScrollTrigger.create({
            trigger: el,
            start:   "top-=60 top",    // pinear 60px después de entrar
            endTrigger: row,
            end:     "bottom-=60 top",     // soltar cuando el bottom de row llegue al top
            pin:     el,
            pinSpacing: false,
            // markers: true,
        });
    });
}

function marqueeCentering() {
    const marquee = document.querySelector('.marquee');
    const inner   = marquee.querySelector('.marquee__inner');

    function pauseMarquee() {
        inner.style.animationPlayState = 'paused';
    }
    function playMarquee() {
        inner.style.animationPlayState = 'running';
    }

    marquee.addEventListener('mousemove', e => {
        const rect = marquee.getBoundingClientRect();
        const xPct = ((e.clientX - rect.left) / rect.width) * 100;
        marquee.style.transformOrigin = `${xPct}% 50%`;
    });

    marquee.addEventListener('mouseenter', () => {
        pauseMarquee();
        // Aplicamos escala
        marquee.style.transform = 'scale(1.0001)';
    });

    marquee.addEventListener('mouseleave', () => {
        // Listener antes de revertir para que se dispare:
        const onTransEnd = ev => {
            if (ev.propertyName === 'transform') {
                marquee.removeEventListener('transitionend', onTransEnd);
                marquee.style.transformOrigin = 'bottom center';
                playMarquee();
            }
        };
        marquee.addEventListener('transitionend', onTransEnd);

        // Aquí revierte la escala y dispara la transición
        marquee.style.transform = 'scale(1)';
    });
}


// END ABOUT//

function portfolioPinHeader() {
    ScrollTrigger.matchMedia({
        "(min-width: 1024px)": function () {
            // Seleccionamos los elementos
            const content = document.querySelector(".project-content");
            const titleEl = content.querySelector(".project-content__title");
            const listEl = content.querySelector(".project-content__list");
            const archiveEl = content.querySelector(".project-content__archive");

            ScrollTrigger.create({
                trigger: content,
                start: "top-=20 top",
                endTrigger: ".project-related",
                end: "top bottom",
                pin: titleEl,
                pinSpacing: false,
                markers: false,
                onToggle: self => {

                    if (self.isActive) {
                        titleEl.classList.add("is-pinned");
                    } else {
                        titleEl.classList.remove("is-pinned");
                    }
                }
            });
            ScrollTrigger.create({
                trigger: content,
                start: "top-=20 top",
                endTrigger: ".project-related",
                end: "top bottom",
                pin: listEl,
                pinSpacing: false,
                markers: false,
                onToggle: self => {

                    if (self.isActive) {
                        listEl.classList.add("is-pinned");
                    } else {
                        listEl.classList.remove("is-pinned");
                    }
                }
            });

            const archivePin = ScrollTrigger.create({
                id: 'archivePin',              //  ←  NUEVO
                trigger: archiveEl,
                start: "bottom+=10 bottom",
                endTrigger: ".project-related",
                end: "top bottom",
                pin: archiveEl,
                pinSpacing: false,
                markers: false,
                onToggle: self => {
                    archiveEl.classList.toggle('is-pinned', self.isActive);
                }
            });
        },
        "all": function () {
        }
    });
}


// CONTACT //

function pinContact() {
    const info = document.querySelector('.contact__info');
    const image = document.querySelector(".contact__image.vertical");

    ScrollTrigger.create({
        trigger: info,
        start: "top-=48% top",
        endTrigger: ".footer",
        end: "top bottom+=15%",
        pin: info,
        pinSpacing: false,
    });
    ScrollTrigger.create({
        trigger: image,
        start: "bottom+=10 bottom",
        endTrigger: ".footer",
        end: "top bottom+=15%",
        pin: image,
        pinSpacing: false,
    });
}

// END CONTACT //

function initScrollUpHeader() {
    const header = document.querySelector('.header');
    if (!header) return;

    let lastScroll = window.scrollY;

    window.addEventListener('scroll', () => {
        const currentScroll = window.scrollY;

        if (currentScroll < lastScroll) {
            // Scroll up
            header.classList.add('scroll-up');
            header.classList.remove('scroll-down');
        } else {
            // Scroll down
            header.classList.remove('scroll-up');
            header.classList.add('scroll-down');
        }

        lastScroll = currentScroll;
    });
}
